//set config (constants)

const config = {
    apiUrl : {
        users : ''
    }
};

export default config;


// WEBPACK FOOTER //
// ./src/config.js